(function (){
    'use strict';

    angular
        .module('services')
        .service('RoleService', RoleService);

    RoleService.$inject = ['$http', 'API_BASE'];

    function RoleService ($http, API_BASE) {
        var service = this;


        service.getUserRoles        = getUserRoles;
        service.getRolePermissions  = getRolePermissions;
        service.getPermissions      = getPermissions;


        function getUserRoles () {

            return $http.get(API_BASE + '/roles');
        }

        function getRolePermissions (id) {
            return $http.get(API_BASE + '/roles/'+id+'/permissions');
        }

        function getPermissions (id) {
            return $http.get(API_BASE + '/permissions/'+id);
        }


    }
})();